import React from 'react'
import {Stack, HStack, Text,
    Slider, SliderTrack, SliderFilledTrack, SliderThumb,
} from "@chakra-ui/react";
import { t } from '@lang/i18n';

const SearchSlider = ({salary_min, onChange, ...rest}) => {

    const sliderConfig = {
        min: 0,
        max: 200,
        step: 10
    };

    return(
        <Stack
            flexDir="column"
            justifyContent="space-evenly"
            borderRadius="5px"
            border="1px solid #888"
            w="15.9rem"
            py=".6rem" px="1rem"
            {...rest}>
            <HStack justifyContent="space-between" alignItems="flex-start">
                <Text fontSize="12px" color="black"> 
                    {t('candidate.search_job.main.salary_min')} 
                </Text>
                <Text color="#00466E" w="90px" textAlign="right" fontSize="14px" fontWeight="bold"> 
                    {salary_min? `${salary_min} K€ / an` : 'Indifférent'} 
                </Text>
            </HStack>

            <Slider 
                aria-label="slider-ex-1" 
                // mt="16px !important"
                // mb="8px !important"
                colorScheme="blue" 
                value={salary_min}
                min={sliderConfig.min} 
                max={sliderConfig.max} 
                step={sliderConfig.step}
                onChange={onChange}>
                    <SliderTrack h="10px">
                        <SliderFilledTrack w="229px" borderRadius="11px" />
                    </SliderTrack>
                    <SliderThumb 
                        bg="white" w="26px" h="26px"
                        boxShadow="0px 1px 6px rgba(0, 0, 0, 0.5)" 
                        _focus={{boxShadow: "0px 1px 6px rgba(0, 0, 0, 0.5)"}} />
            </Slider>

            <HStack justifyContent="space-between" fontSize="12px" color="#6C6C6C">
                <Text> {sliderConfig.min} €/ an </Text>
                <Text> {sliderConfig.max} K€/ an </Text>
            </HStack>
        </Stack>
    )
}
export default SearchSlider;
